import type { App } from '../app/App';
import { heroClass } from '../game/data/presets';
import { heroNameProblem, isClassName, randomHeroName } from '../game/systems/heroSlots';
import { language, t } from '../i18n';
import { button, modal } from './components';
import { h } from './dom';

let asking = false;

/**
 * Heroes made before names were required are still called by their class
 * name ("Pencil Knight"). The notebook asks for a real name, one hero at a
 * time; the dialog cannot be skipped.
 */
export async function requireHeroNames(app: App): Promise<void> {
  if (asking) return;
  asking = true;
  try {
    for (const hero of app.store.state.heroes.filter((x) => isClassName(x.name, x.classId))) {
      const input = h('input', { class: 'hand-input big', maxLength: 24, value: '', placeholder: t("Your hero's name"), 'aria-label': t('Hero name') });
      const error = h('p', { class: 'field-error', role: 'alert' });
      input.addEventListener('input', () => (error.textContent = ''));
      const body = h(
        'div',
        { class: 'hero-rename' },
        h('p', null, t('Your {cls} needs a name of its own. What is your hero called?', { cls: t(heroClass(hero.classId).name) })),
        h('span', { class: 'name-row' }, input, button('🎲', { small: true, title: t('A random name'), sfx: app, onClick: () => ((input.value = randomHeroName(language())), (error.textContent = '')) })),
        error,
      );
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') (body.closest('.modal-card')?.querySelector('.sketch-btn.primary') as HTMLButtonElement | null)?.click();
      });
      await modal(t('Name your hero'), body, [{ label: t('Save name'), value: 'ok', variant: 'primary', color: 'yellow' }], {
        dismissable: false,
        accept: () => {
          const problem = heroNameProblem(input.value, hero.classId);
          error.textContent = problem ?? '';
          if (problem) return false;
          const name = input.value.trim();
          app.store.update(['hero'], (s) => {
            const x = s.heroes.find((y) => y.id === hero.id);
            if (x) x.name = name;
          });
          app.toast(t('Nice to meet you, {name}!', { name }), 'success');
          return true;
        },
      });
    }
  } finally {
    asking = false;
  }
}
